export function sleep(sec: any) {
    return new Promise((resolve) => setTimeout(resolve, sec * 1000));
}
